import { createBaseResponseSchema, vendorSchema, yesNoSchema } from '@server/presentation'
import { z } from 'zod'

export const getRawPaymentMethodsResSchema = createBaseResponseSchema(
  z.object({
    vendor: vendorSchema,
    card_name: z.string(),
    debit_yn: yesNoSchema,
    card_bin4: z.string().nullable(),
    id: z.string(),
  }),
)

export const getPaymentMethodsResSchema = z.object({
  id: z.string(),
  name: z.string(), // 카카오페이 또는 카드명
  cardNumber: z.string().nullable(), // 카드인 경우 카드번호 앞 4자리(BIN), 간편결제 또는 조회 실패 시 null
  vendor: vendorSchema,
})

export const rawGetRegisteredPaymentFailResSchema = createBaseResponseSchema(z.null())

export type GetRawPaymentMethodsRes = z.infer<typeof getRawPaymentMethodsResSchema>
export type GetPaymentMethodsRes = z.infer<typeof getPaymentMethodsResSchema>
export type RawGetRegisteredPaymentFailRes = z.infer<typeof rawGetRegisteredPaymentFailResSchema>
